export default function checkoutCoupon({ main, on, elm }) {
	const cart = elm.closest('[data-cart]');
	const input = elm.querySelector('input');

	main(_ => {
		on('click', '[data-apply]', apply);
	});

	const apply = async function () {
		const action = `index.php?route=extension/opencart/checkout/coupon.save`;
		const params = new URLSearchParams();
		params.append('coupon', input.value);

		try {
			const response = await fetch(action, {
				method: 'POST',
				body: params,
			});

			if (!response.ok) {
				throw new Error(`HTTP error! Status: ${response.status}`);
			}

			const result = await response.json();
			if (result.error) {
				alert(`Error: ${result.error}`);
			} else {
				await cart.update();
			}
		} catch (e) {
			alert(`Error: ${e.message}`);
		}
	};
};

export const model = {};
